const apiUrlBase = 'https://kdta9hzh3m.execute-api.us-east-1.amazonaws.com/personal/api'

const buildHeader = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${window.sessionStorage.getItem('token')}`
  }
}

const saveTournamentOnRound = async (tournamentId, step) => {
  return window.fetch(`${apiUrlBase}/tm/tournaments/${tournamentId}`, {
    method: 'PUT',
    headers: buildHeader(),
    body: JSON.stringify({
      currentSchedule: step
    })
  })
}

const completeTournament = async (tournamentId, step) => {
  return window.fetch(`${apiUrlBase}/tm/tournaments/${tournamentId}`, {
    method: 'PUT',
    headers: buildHeader(),
    body: JSON.stringify({
      currentSchedule: step,
      completed: true
    })
  })
}

const saveTournament = async (tournament) => {
  return window.fetch(`${apiUrlBase}/tm/tournaments`, {
    method: 'POST',
    headers: buildHeader(),
    body: JSON.stringify(tournament)
  })
}

const getTournaments = async () => {
  const data = await window.fetch(`${apiUrlBase}/tm/tournaments`, {
    method: 'GET',
    headers: buildHeader()
  }).then(res => res.json())

  return data
}

const getTournament = async (tournamentId) => {
  const data = await window.fetch(`${apiUrlBase}/tm/tournaments/${tournamentId}`, {
    method: 'GET',
    headers: buildHeader()
  }).then(res => res.json())

  return data
}

const removeTournament = async (tournamentId) => {
  return window.fetch(`${apiUrlBase}/tm/tournaments/${tournamentId}`, {
    method: 'DELETE',
    headers: buildHeader()
  })
}

const saveImage = async (tournamentId, file) => {
  const formData = new window.FormData()
  formData.append('File', file)

  const headers = buildHeader()
  delete headers['Content-Type']

  const data = window.fetch(`${apiUrlBase}/tm/tournaments/${tournamentId}/images`, {
    method: 'POST',
    headers,
    body: formData
  }).then(res => res.json())

  return data
}

const shareTournament = async (tournamentId, users) => {
  return window.fetch(`${apiUrlBase}/tm/tournaments/${tournamentId}/users`, {
    method: 'PUT',
    headers: buildHeader(),
    body: JSON.stringify({
      users
    })
  })
}

export {
  saveTournament,
  getTournaments,
  getTournament,
  removeTournament,
  saveTournamentOnRound,
  completeTournament,
  saveImage,
  shareTournament
}
